import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
const HistoryContext = createContext({
    history: [],
    canGoBack: false,
});
export const HistoryProvider = ({ children }) => {
    const location = useLocation();
    const [history, setHistory] = useState([]);
    const [canGoBack, setCanGoBack] = useState(false);
    useEffect(() => {
        setHistory(prev => {
            const newHistory = [...prev, location];
            setCanGoBack(newHistory.length > 1);
            return newHistory;
        });
    }, [location]);
    return (_jsx(HistoryContext.Provider, { value: { history, canGoBack }, children: children }));
};
export const useHistory = () => useContext(HistoryContext);
